import React from 'react';
import { useAuth } from '../context/AuthContext';
import { getUserInitials } from '../utils/helpers';

function UserAvatar({ user: propUser, size = 'md' }) {
  const { user: contextUser } = useAuth();
  const user = propUser || contextUser;
  
  const displayText = user?.name 
    ? getUserInitials(user.name)
    : 'U';
    
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base'
  };
    
  return (
    <div className={`${sizeClasses[size]} bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 shadow-sm`}>
      {displayText}
    </div>
  );
}

export default UserAvatar;
